// Added by Jonghyung Lee on 2022-02-17
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios, { AxiosInstance } from 'axios'

import { getQueryString } from '@/helper/util'
import { GetQueryReturn } from '@/helper/define'
import { PACSQRInterface } from '@/helper/define/pacsqrDefine'

let PACSQR: AxiosInstance
export const initPacsQR = (baseURL?: string) => {
  if (baseURL) {
    PACSQR = axios.create({
      baseURL,
    })
  }
}

export const reqGetPacsQRList = async (query?: any) => {
  const queryStr = getQueryString<any>(query)
  return await PACSQR.get<GetQueryReturn<PACSQRInterface>>(`/api/v1/dicomweb/qr/tasks${queryStr}`)
}

export const reqPostRestartPacsQR = async (id: string) => {
  return await PACSQR.post('/api/v1/dicomweb/qr/tasks:restart', { id })
}
